import { Card, Grid, Icon } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import React, { useEffect, useState, useRef } from "react";
import { useMaterialUIController } from "context";
import { get, postNoResponse } from "utils/WebService";
import SolicitacaoTreeModal from "./SolicitacaoTreeModal";

export default function ConsultSolicitacoes({ onNewClick, onEditClick }) {
    const [solicitacoes, setSolicitacoes] = useState([]);
    const [filterOption, setFilterOption] = useState("ATRIBUIDO_A_MIM");
    const [statusOption, setStatusOption] = useState(3); // 3 = Pendente

    const [controller] = useMaterialUIController();
    const { darkMode } = controller;

    const [openTreeModal, setOpenTreeModal] = useState(false);
    const [selectedEntity, setSelectedEntity] = useState(null);

    const tableState = useRef({ pageSize: 10, pageIndex: 0, sorting: [] });
    const [filtered, setFiltered] = useState([]);
    const [changeFilter, setChangeFilter] = useState(false);

    const loadData = () => {
        let url = `/solicitacoes/consulta?filterType=${filterOption}`;
        if (statusOption !== 0) {
            url += `&status=${statusOption}`; // 1 Concluido, 2 Agendado, 3 Pendente
        }
        get(url).then(res => setSolicitacoes(res)).catch(() => setSolicitacoes([]));
    }

    useEffect(() => {
        loadData();
    }, [filterOption, statusOption]);

    const handleOpenTree = (row) => {
        setSelectedEntity(row);
        setOpenTreeModal(true);
    };

    const columns = [
        { header: "ID", accessorKey: "id", width: "5%" },
        { header: "Título", accessorKey: "titulo", width: "30%" },
        { header: "Criador", accessorKey: "nomeUsuarioCriador", width: "20%" },
        { header: "Responsável", accessorKey: "nomeUsuarioResponsavel", width: "20%" },
        { 
            header: "Urgente", 
            accessorKey: "urgente", 
            cell: ({ getValue }) => {
                const value = getValue();
                return (
                    <MDTypography variant="caption" color={value ? "error" : "text"} fontWeight={value ? "bold" : "regular"}>
                        {value ? "Sim" : "Não"}
                    </MDTypography>
                );
            }
        },
        { 
            header: "Detalhes", 
            accessorKey: "actions", 
            width: "10%",
            cell: ({ row }) => (
                <MDBox display="flex" gap={1}>
                    <MDButton variant="text" color="info" size="small" onClick={() => onEditClick(row.original, filterOption)} title="Visualizar/Editar & Mudar Status">
                        <Icon>edit</Icon>
                    </MDButton>
                    <MDButton variant="text" color="info" size="small" onClick={() => handleOpenTree(row.original)} title="Ver Ramificação/Árvore">
                        <Icon>account_tree</Icon>
                    </MDButton>
                </MDBox>
            )
        }
    ];

    return (
        <MDBox pt={2} pb={3}>
            <Card
                variant="outlined"
                sx={{
                    px: 2,
                    py: 1.5,
                    mb: 2,
                    background: darkMode ? "#4B4F5C" : "#fafafa",
                    borderColor: darkMode ? "#333" : "#ddd",
                }}
            >
                <MDBox display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={2}>
                    <MDBox display="flex" gap={2} flexWrap="wrap">
                        <MDButton 
                            variant={filterOption === "ATRIBUIDO_A_MIM" ? "gradient" : "outlined"} 
                            color={filterOption === "ATRIBUIDO_A_MIM" ? "dark" : (darkMode ? "white" : "dark")} 
                            size="small" 
                            onClick={() => setFilterOption("ATRIBUIDO_A_MIM")}>
                            Atribuídos a Mim
                        </MDButton>
                        <MDButton 
                            variant={filterOption === "CRIADO_POR_MIM" ? "gradient" : "outlined"} 
                            color={filterOption === "CRIADO_POR_MIM" ? "dark" : (darkMode ? "white" : "dark")} 
                            size="small" 
                            onClick={() => setFilterOption("CRIADO_POR_MIM")}>
                            Criados por Mim
                        </MDButton>
                        
                        <MDBox mx={1} borderLeft={darkMode ? "1px solid #555" : "1px solid #ccc"} />

                        <MDButton variant={statusOption === 3 ? "gradient" : "outlined"} color="warning" size="small" onClick={() => setStatusOption(3)}>
                            Pendentes
                        </MDButton>
                        <MDButton variant={statusOption === 2 ? "gradient" : "outlined"} color="info" size="small" onClick={() => setStatusOption(2)}>
                            Agendados
                        </MDButton>
                        <MDButton variant={statusOption === 1 ? "gradient" : "outlined"} color="success" size="small" onClick={() => setStatusOption(1)}>
                            Concluídos
                        </MDButton>
                    </MDBox>

                    <MDButton size="medium" variant="contained" color="info" onClick={onNewClick}>
                        NOVA SOLICITAÇÃO
                    </MDButton>
                </MDBox>
            </Card>

            <Card>

                <DataTable
                    columnData={columns}
                    data={solicitacoes || []}
                    totalRecords={solicitacoes?.length || 0}
                    totalPages={1}
                    tableState={tableState}
                    fetchData={() => {}}
                    filtered={filtered}
                    setFiltered={setFiltered}
                    changeFilter={changeFilter}
                    isSorted={true}
                    entriesPerPage={{ defaultValue: 10, entries: [5, 10, 15, 20, 25] }}
                    showTotalEntries={true}
                    noEndBorder
                />
            </Card>

            {openTreeModal && (
                <SolicitacaoTreeModal 
                    open={openTreeModal} 
                    onClose={() => setOpenTreeModal(false)} 
                    solicitacao={selectedEntity} 
                />
            )}
        </MDBox>
    );
}
